import styled, { css } from 'styled-components';
import { HeaderCloseButton } from 'src/components/Sidebar/styled';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;
const { LOGO_WIDTH, LOGO_HEIGHT } = constants.logos;

// Sidebar layout components
export const ExtendedSidebarContentContainer = styled.div`
  height: 100%;
`;

// revert attribute header link
export const RevertAttributeLink = styled.div`
  display: inline-block;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.defaultActionBlue};
  }
`;

export const BackIcon = styled(HeaderCloseButton)`
  display: flex;
  position: relative;
  padding-left: 10px;
  transform: rotate(180deg);

  g g {
    fill: ${({ theme }) => theme.colors.black};
  }
`;

// extended sidebar header components
export const Header = styled.div`
  position: relative;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.lightGrayText};
`;

export const BackButton = styled.div`
  ${({ theme }) => theme.mixins.fontWeights.book};
  position: relative;
  color: ${({ theme }) => theme.colors.black};
  font-size: 14px;
  cursor: pointer;
`;

export const HeaderTitle = styled.div`
  font-size: 16px;
  line-height: 19px;
  color: ${({ theme }) => theme.colors.mediumGrayText};
`;

export const SelectorContent = styled.div`
  position: absolute;
  padding: 20px;

  @media ${DEVICE.MOBILE} {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
`;

// variation group components
export const VariationGroup = styled.div`
  margin-bottom: 4px;
  height: 22px;
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  padding: 5px 0 0 8px;
  vertical-align: middle;
  text-transform: capitalize;
  cursor: pointer;

  ${({ theme, isSelected }) => {
    return isSelected
      ? css`
          color: ${theme.colors.white};
          background-color: ${theme.colors.variationGray};
          border-radius: 2px;
        `
      : css`
          color: ${theme.colors.defaultActionBlue};
        `;
  }}
`;

export const Divider = styled.div`
  margin-top: 16px;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.zircon};
`;

// menu item components
export const MenuItemName = styled.div`
  font-size: 12px;
  width: 194px;

  @media ${DEVICE.MOBILE} {
    max-width: 190px;
    width: auto;
  }
`;

export const PaintItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const PaintbrushIconContainer = styled.div`
  display: inline-block;

  .hv-svg svg {
    height: 32px;
    width: 32px;

    path {
      fill: white;
    }
  }
`;

export const MenuItemImage = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
  margin-bottom: 4px;
  border: solid 1px ${({ theme }) => theme.colors.mischka};
  border-radius: 2px;
  height: 58px;
  width: 194px;
  background-color: ${({ theme, color }) => color || theme.colors.sidebarGray};
  background-size: contain;
  background-position: center;

  @media ${DEVICE.MOBILE} {
    max-width: 190px;
    width: auto;
    height: 0px;
    padding-top: calc(${LOGO_HEIGHT} / ${LOGO_WIDTH} * 100%);
  }

  ${({ color, imageUrl, isEditingProduct, isBrand }) => {
    // show image url when selecting the following
    // materials, brands, products, and roof colors (some products will have both a color and a url)
    if (isEditingProduct || (!color && imageUrl)) {
      if (isBrand) {
        return css`
          background-image: url(${imageUrl});
          background-repeat: no-repeat;
          background-color: ${({ theme }) => theme.colors.white};
        `;
      } else {
        return css`
          background-image: url(${imageUrl});
        `;
      }
    }
  }}
`;

export const MenuItemContainer = styled.div`
  margin-bottom: ${({ isLastItem }) => (isLastItem ? '100px' : '6px')};

  @media ${DEVICE.MOBILE} {
    width: 50%;
    padding: 10px;
  }

  &:hover {
    cursor: pointer;
    ${MenuItemImage} {
      border: solid 1px
        ${({ theme, isSelected }) =>
          isSelected ? theme.colors.black : theme.colors.defaultActionBlue};
    }
    ${({ theme, isSelected }) => css`
      ${MenuItemName} {
        color: ${isSelected
          ? theme.colors.black
          : theme.colors.defaultActionBlue};
      }
    `}
  }

  ${({ theme, isSelected }) => {
    if (isSelected) {
      return css`
        ${MenuItemName} {
          ${theme.mixins.font('bold', 12)}
        }
        ${MenuItemImage}:before {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 16px;
          height: 16px;
          line-height: 16px;
          font-size: 12px;
          text-align: center;
          color: ${theme.colors.white};
          background-color: ${theme.colors.defaultNavy};
          border: solid 1px ${theme.colors.defaultNavy};
          content: '\\2713';
        `;
    }
  }}
`;

// selection unavailable components
export const SelectionUnavailableContainer = styled.div`
  border-radius: 4px;
  padding: 20px 12px;
  background-color: ${({ theme }) => theme.colors.extraLightGray};

  @media ${DEVICE.MOBILE} {
    margin: 0px 20px;
  }
`;

export const SelectionUnavailableIcon = styled.div`
  display: inline-block;
  height: 16px;
  vertical-align: middle;
`;

export const SelectionUnavailableContent = styled.div`
  display: inline-block;
  margin-left: 20px;
  height: 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.border};
`;
